export const formatDate = (date) => {
    const currentDate = new Date(date) || new Date(); // Use the provided date or the current date if not provided.
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = currentDate.getFullYear();
    const formatted = `${day}-${month}-${year}`;
    return formatted;
  };

export const formatChatDate = (value) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();
  const hour24 = date.getHours();
  const hour = String(hour24 % 12 || 12).padStart(2, "0");
  const minute = String(date.getMinutes()).padStart(2, "0");
  const period = hour24 >= 12 ? "PM" : "AM";
  return `${day} ${month}, ${year} . ${hour}:${minute} ${period}`;
};
